export default {"src":"/evde-internet/_next/static/media/redAlert.5d9f25db.svg","height":96,"width":96};